import { InterventionEvent } from '../scripts/interventions.entities'; 
type SimpleNumMap = { [key in number]: number }
export class InterventionsDatatableEntry {
    Study: string;
    Appendix: string;
    Site: string;
    SiteNumber: string;

    PotentialInterventions: number;
    ExpectedInterventions: number;
    Completed: number[] = [];
    Partial: number[] = [];
    Ongoing: number[] = [];
    NotDone: number[] = [];
    DiscPrior: number[] = [];
    DisconReasonCounts: SimpleNumMap = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        7: 0,
        10: 0,
        11: 0,
        12: 0
    };
    DNCReasonCounts: SimpleNumMap = {
        17: 0,
        16: 0,
        8: 0,
        12: 0,
        13: 0,
    };
    
;

    CompletedInterventions: InterventionEvent[] = [];
    PartialInterventions: InterventionEvent[] = [];
    OngoingInterventions: InterventionEvent[] = [];
    NotDoneInterventions: InterventionEvent[] = [];
    DiscPriorInterventions: InterventionEvent[] = [];

    sortValue: number;

    constructor(study: string, appendix: string, site: string, siteNumber: string) {
        this.Study = study;
        this.Appendix = appendix;
        this.Site = site;
        this.SiteNumber = siteNumber;

        this.PotentialInterventions = 0;
        this.ExpectedInterventions = 0;
    }

    addInterventionEvent(intervention: InterventionEvent): void {
        this.PotentialInterventions += 1;

        let currentCount = this.DisconReasonCounts[intervention.DisconInterventionReasonId];
        this.DisconReasonCounts[intervention.DisconInterventionReasonId] = InterventionsDatatableEntry.addValue(currentCount, 1);


        let dncReasonID = ([3,4,5,6,9,10,11,15]).includes(intervention.DncInterventionReasonId) ? 12 : intervention.DncInterventionReasonId;
        currentCount = this.DNCReasonCounts[dncReasonID]
        this.DNCReasonCounts[dncReasonID] = InterventionsDatatableEntry.addValue(currentCount, 1);


        switch (intervention.InterventionStatusId) {
            case 0: //never started
                this.NotDone[0] = (this.NotDone[0] == undefined) ? 1 : (this.NotDone[0] + 1);
                this.ExpectedInterventions += 1;
                this.NotDoneInterventions.push(intervention);
                break;
            case 1: //discontinued early
                this.DiscPrior[0] = (this.DiscPrior[0] == undefined) ? 1 : (this.DiscPrior[0] + 1);
                this.ExpectedInterventions += 1;
                this.DiscPriorInterventions.push(intervention);
                break;
            case 2: //completed (full course)
                this.Completed[0] = (this.Completed[0] == undefined) ? 1 : (this.Completed[0] + 1);
                this.ExpectedInterventions += 1;
                this.CompletedInterventions.push(intervention);
                break;
            case 3: //completed (incomplete dose(s)/session(s))
                this.Partial[0] = (this.Partial[0] == undefined) ? 1 : (this.Partial[0] + 1);
                this.ExpectedInterventions += 1;
                this.PartialInterventions.push(intervention);
                break;
            case 4: //ongoing
                this.Ongoing[0] = (this.Ongoing[0] == undefined) ? 1 : (this.Ongoing[0] + 1);
                this.ExpectedInterventions += 1;
                this.OngoingInterventions.push(intervention);
                break;

        }
    }

    initialize(): void {
        if (this.ExpectedInterventions > 0) {
            if (this.Completed[0] != undefined) { this.Completed[1] = (this.Completed[0] / this.ExpectedInterventions); }
            if (this.Partial[0] != undefined) { this.Partial[1] = (this.Partial[0] / this.ExpectedInterventions); }
            if (this.Ongoing[0] != undefined) { this.Ongoing[1] = (this.Ongoing[0] / this.ExpectedInterventions); }
            if (this.NotDone[0] != undefined) { this.NotDone[1] = (this.NotDone[0] / this.ExpectedInterventions); }
            if (this.DiscPrior[0] != undefined) { this.DiscPrior[1] = (this.DiscPrior[0] / this.ExpectedInterventions); }
        }
    }


    static addValue(currentValue: number, valueToAdd: number): number {
        if (currentValue == undefined) { currentValue = 0; }
        currentValue += valueToAdd;
        return currentValue;
    }


    static getHash(grouping: string, intervention: InterventionEvent): string {
        //if (grouping == "none") { return intervention.StudyId + "-" + intervention.AppendixId + "-" + intervention.SiteNumber + "-" + intervention.InterventionStatusId }
        //else if (grouping == "by-site") { return intervention.StudyId + "-" + intervention.AppendixId + "-" + intervention.SiteNumber }
        //else return "unknown";

        return intervention.StudyId + "-" + intervention.AppendixId + "-" + intervention.SiteNumber;
    }

}